<template>
	<div>
		我是agentDashboard
	</div>
</template>
<script>
	export default {
		name:'agentDashboard'
	}
</script>
